import {userProfile} from '@netx/core-user/collections/singletons/userProfile';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset, AssetStatus} from '../schema';

export const canCheckIn = (asset?: IAsset) => {
	if (!asset) return false;

	const checkedOutBy = asset.checkout;
	if (
		checkedOutBy &&
		!currentUserMeetsUserLevel(UserLevel.ADMIN) &&
		checkedOutBy !== userProfile.id
	)
		return false;

	// https://jira.netx.net/browse/DAM-13370
	return (
		currentUserMeetsUserLevel(UserLevel.PRODUCER) &&
		allows(asset.permissionMatrix, PermissionMatrixName.MODIFY) &&
		[
			AssetStatus.NEARLINE,
			AssetStatus.ONLINE,
			AssetStatus.TEMP,
			AssetStatus.CHECKOUT,
		].includes(asset.status)
	);
};
